import { render, staticRenderFns } from "./DiffCell.vue?vue&type=template&id=d27a13f2&"
import script from "./DiffCell.vue?vue&type=script&lang=js&"
export * from "./DiffCell.vue?vue&type=script&lang=js&"
import style0 from "./DiffCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports